export default "__VITE_PUBLIC_ASSET__b74dd3a9__"